
jQuery(function($){
  $('a.shg-btn').click(function(e){
    e.preventDefault();
  });
  $('.shogun-accordion-heading').click(function(e){
    if($(this).next().is(':visible')){
      $(this).find('span').css('transform','rotate(90deg)');
    }else{
      $(this).find('span').css('transform','rotate(-135deg)');
    }
    $(this).next().slideToggle();
  });
  $('.shg-btn-wrapper a').lightcase();


  //var ids = ['creature','interview'];
  $('.shg-btn-wrapper a').each(function(){
    var id = $(this).attr('id');
    var target = $(this).attr('href').replace('#','');
    if(id == 'product-btn-creature'){
      getCreatureObj(target);
    }else if(id == 'product-btn-interview'){
      getInterviewObj(target);
    }
  });

  $('.tabs a').click(function(e){
      e.preventDefault();
      var target = $(this).attr('href');
      $('.tab').hide();
      $(target).show();
      $('.tabs a').removeClass('active');
      $(this).addClass('active')
  });
  
  
  function getCreatureObj(target){
    $.ajax( {
      url: "//f-favorite.net/cdn/shop/t/98/assets/product-creature-en.csv?v=84680448139263859461781753110",
      type: 'get',
      dataType : 'text',
      cache : false,
      success: function( data ) {
        //alert(data); 
        var json = csvToJson(data, { header : 1, columnName : ['id', 'name', 'enname','cat','size','era','body'] });;
        for(obj of json){
          if(obj.id == target){
			var html = '<h3>'+obj.enname+'<!--<span>'+obj.enname+'</span>--></h3>';
            if(obj.cat != ''){ html += '<p>Classification: '+obj.cat+'<br>';}
            //if(obj.size != ''){ html += 'サイズ　：'+obj.size+'<br>';}
            if(obj.era != ''){ html += 'Habitat: '+obj.era+'</p>';}

            html += '<p>'+obj.body+'</p>';
            $('.product-box-creature').html(html);
            $('.product-box-creature').attr('id',target);
            break;
          }
        }
      }
    });
  }
  

  function getInterviewObj(target){
    var csv1,csv2;
    var path1 = "//f-favorite.net/cdn/shop/t/98/assets/product-interview-en.csv?v=53325831223048888111781753110";
    var path2 = "//f-favorite.net/cdn/shop/t/98/assets/product-supervisor-en.csv?v=36887090022262478441781753110";
    console.log("start");
    var d = $.Deferred();
    
    $.when(
      $.ajax({url:path1}).done(function(data){csv1=data;d.resolve();}),
      $.ajax({url:path2}).done(function(data){csv2=data;d.resolve();})
      ).done(function(data){
        var json1 = csvToJson(csv1, { header : 1, columnName : ['id', 'name', 'body'] });;
        var json2 = csvToJson(csv2, { header : 1, columnName : ['sname', 'skana', 'sbody'] });;
        for(i=0;i<json1.length;i++){
          if(json1[i].id == target){
			var html = '<h3>Interview with '+json1[i].name+'</h3>';
            html += json1[i].body;
            for(e=0;e<json2.length;e++){
              if(json1[i].name == json2[e].sname){
                html += '<h4 class="underline">Supervisor profile</h4>';
                html += '<h3>' + json2[e].sname + '</h3>';
                html += '<p>' + json2[e].sbody + '</p>';
                break;
              }
            }
            $('.product-box-interview').html(html);
            $('.product-box-interview').attr('id',target);
            break;
          }
        }
    });
  }

  var csvToJson = function(csvStr, userOptions) {
      if (typeof csvStr !== 'string') return null;

      var options = { header : 0, columnName : [], ignoreBlankLine : true };

      if (userOptions) {
          if (userOptions.header) options.header = userOptions.header;
          if (userOptions.columnName) options.columnName = userOptions.columnName;
      }

      var rows = csvStr.split('\n');
      var json = [], line = [], row = '', data = {};
      var i, len, j, len2;

      for (i = 0, len = rows.length; i < len; i++) {
          if ((i + 1) <= options.header) continue;
          if (options.ignoreBlankLine && rows[i] === '') continue;

          line = rows[i].split('<>');

        
          if (options.columnName.length > 0) {
              data = {};
              for (j = 0, len2 = options.columnName.length; j < len2; j++) {
                  if (typeof line[j] !== 'undefined') {
                      row = line[j];
                      row = row.replace(/^"(.+)?"$/, '$1');
                  } else {
                      row = null;
                  }

                  data[options.columnName[j]] = row;
              }
              json.push(data);
          } else {
              json.push(line);
          }
      }

      return json;
  };
  
  
});